import styled from 'styled-components';

const ShareQR = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  padding: 12px;
  position: relative;
`;

const IconWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border-radius: 32px;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

const ShareQRText = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.48);
  border-radius: 4px;
  color: var(---color-fg-inverse-default);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const ShareQRBox = styled.div`
  svg {
    max-height: 100%;
    max-width: 100%;
  }
`;

const ShareQRTextTypes = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

const ShareQRTextType = styled.button`
  background-color: var(--color-bg-body);
  opacity: 0.8;
  padding: 2px 6px;
  transition: opacity 0.2s;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;

export { IconWrapper, ShareQR, ShareQRBox, ShareQRText, ShareQRTextType, ShareQRTextTypes };
